









import { ROUTE_WORKFLOW_ADD, ROUTE_WORKFLOW_DETAILS } from '@/areas/claims/claims-routes';
import { ROUTE_CONTRACT_DEFAULT } from '@/areas/projects/contracts/contract-routes';
import OtApi, { executeApi } from '@/services/api.service';
import { ApiOpenSegmentStatusSet } from '@/types/status-enums';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class OtGoTo extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private api = new OtApi();

  // * COMPUTED
  private get contractGid() {
    const contractGid = this.$route.query.contractGid;
    if (!contractGid) {
      return null;
    }
    if (typeof contractGid === 'string') {
      return contractGid;
    }
    return contractGid[0];
  }
  private get workflowGid() {
    const workflowGid = this.$route.query.workflowGid;
    if (!workflowGid) {
      return null;
    }
    if (typeof workflowGid === 'string') {
      return workflowGid;
    }
    return workflowGid[0];
  }

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
  private async created() {
    // yes, this const stuff is a pain in the fleshy things you sit on
    // but, the executeApi is a callback, and by the time it executes, typescript quite rightly complains that the variable
    // might be undefined. So we need to declare it outside the if, and then do the closure around it
    const workflowGid = this.workflowGid;
    if (workflowGid) {
      const result = await executeApi(
        () => this.api.segmentInstances().getSegmentInstanceDetails(workflowGid),
        'Load Workflow Details',
      );
      // open claims go to the add claim wizard
      if (result.data?.status && ApiOpenSegmentStatusSet.has(result.data?.status)) {
        this.$router.push({
          name: ROUTE_WORKFLOW_ADD,
          query: { claimGid: workflowGid },
        });
        return;
      }

      // non open claims go to the claim details
      const projectGid = result.data?.project.gid;
      if (!projectGid) {
        console.error('No project gid found for workflow gid', workflowGid);
        return;
      }
      const contractGid = result.data?.contract.gid;
      if (!contractGid) {
        console.error('No contract gid found for workflow gid', workflowGid);
        return;
      }

      this.$router.replace({
        name: ROUTE_WORKFLOW_DETAILS,
        params: { projectGid, contractGid, claimGid: workflowGid },
      });
      return;
    }

    const contractGid = this.contractGid;
    if (contractGid) {
      const result = await executeApi(
        () => this.api.contracts().getContractDetails(contractGid),
        'Load Contract Details',
      );
      const projectGid = result.data?.contract?.projectGid;
      if (!projectGid) {
        console.error('No project gid found for contract gid', contractGid);
        return;
      }
      console.log('Redirecting to', ROUTE_CONTRACT_DEFAULT, { projectGid, contractGid });
      this.$router.replace({ name: ROUTE_CONTRACT_DEFAULT, params: { projectGid, contractGid } });
      return;
    }
  }
}
